import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { listViewStore, getInboxClassificationFilterForTable } from 'owa-mail-list-store';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { orchestrator } from 'satcheljs';
import { onInboxPivotSelected } from '../actions/onInboxPivotSelected';
import { onPivotEnableDisableDialogSave } from 'owa-mail-inbox-plus-store';
import getSelectedTableViewId from 'owa-mail-list-store/lib/utils/getSelectedTableViewId';
import { createLazyOrchestrator } from 'owa-bundling';
import updateAlwaysInCacheTableIds from 'owa-mail-list-actions/lib/actions/helpers/tableCache/updateAlwaysInCacheTableIds';
import { isFeatureEnabled } from 'owa-feature-flags';

orchestrator(onInboxPivotSelected, actionMessage => {
    return loadTableViewForInboxPlusPivot(actionMessage.pivotToSelect, actionMessage.tableViewId);
});

//If The user is disabling the current selected pivot, we need to reset selection to the leftmost pivot
export const changeTableViewOnDialogSave = createLazyOrchestrator(
    onPivotEnableDisableDialogSave,
    'clone_onPivotEnableDisableDialogSave',
    async actionMessage => {
        const currentTableViewId = getSelectedTableViewId();
        const currentSelectedPivot = getInboxClassificationFilterForTable(currentTableViewId);
        const enabledPivotsToSet = actionMessage.pivotsToSet
            .filter(pivot => pivot.isEnabled)
            .map(pivot => pivot.InboxClassificationFilter);
        const isDisablingCurrentSelectedPivot =
            enabledPivotsToSet.indexOf(currentSelectedPivot) === -1;

        // User is disabling the current selected pivot. Reset selection to the leftmost pivot
        // and update cached tables
        if (isDisablingCurrentSelectedPivot) {
            loadTableViewForInboxPlusPivot(enabledPivotsToSet[0], currentTableViewId);
            updateAlwaysInCacheTableIds();
        }
    }
);

function loadTableViewForInboxPlusPivot(
    pivotToSelect: InboxClassificationFilter,
    currentTableViewId: string
): Promise<void> {
    const selectedTableView = listViewStore.tableViews.get(currentTableViewId);
    let focusedViewFilter;

    switch (pivotToSelect) {
        case InboxClassificationFilter.Focused:
            focusedViewFilter = FocusedViewFilter.Focused;
            break;
        case InboxClassificationFilter.Other:
            focusedViewFilter = FocusedViewFilter.Other;
            break;
        default:
            // When user is on Focused inclusion flight, all non-Focused tabs only contain items
            // classified as Other
            focusedViewFilter = isFeatureEnabled('tri-inboxPlusEasyOn')
                ? FocusedViewFilter.Other
                : FocusedViewFilter.None;
            break;
    }

    // Always reset the view filter when user switches the focused pivot
    const tableQuery = createMailFolderTableQuery(
        selectedTableView.tableQuery.folderId,
        selectedTableView.tableQuery.listViewType,
        'mail',
        focusedViewFilter,
        null /* viewFilter */,
        null /* categoryName */,
        null /* sortBy */,
        pivotToSelect
    );

    listViewStore.rowInfoForVLV.clear();
    listViewStore.scrollTop = 0;

    return loadTableViewFromTableQuery(tableQuery);
}
